<template>
    <div id="repairremind">
        <!-- <van-nav-bar
            title="我的保养"
            left-arrow
        /> -->
        <van-loading vertical v-if="loading"/>
        <van-cell is-link :title="curCar" @click="showCar = true"/> 
        <van-action-sheet v-model="showCar" :actions="cars" @select="chgCar" />
        <van-cell-group :title="item['service_name']" v-for="item in curData" :key="item.id">
            <van-cell title='上次更换时间' :value="item['pre_date']" />
            <van-cell title='上次更换里程' :value="(item['pre_distince']==null? '0' : item['pre_distince'])  + 'KM'"/>
            <van-cell title='下次更换时间' :value="item['plan_date']"/>
            <van-cell title='下次更换里程' :value="(item['plan_distince']==null? '0': item['plan_distince']) + 'KM'"/>
        </van-cell-group>
    </div>
</template>

<script>
import { NavBar,  Loading, Cell, CellGroup, ActionSheet } from 'vant';
import { RepairRemindApi } from '@/api/vip'
import { toErrorPage } from '@/utils/usePage'

export default {
    components: {
        [NavBar.name]: NavBar,
        [Loading.name]: Loading,
        [Cell.name]: Cell,
        [CellGroup.name]: CellGroup,
        [ActionSheet.name]: ActionSheet
    },
    data() {
        return {
            curCar: '',
            curData: [],
            showCar: false,
            cars: [],
            data: [],
            loading: true
        }
    },
    mounted(){
        this.getMaintenance()
    },
    methods: {
        getMaintenance(){
            var that = this
            that.axios.get(RepairRemindApi).then((ret) => {
               console.log(ret)
               this.loading = false
               if (ret.flag) {
                   ret = ret.details
                    var carTmp = []
                    var idx = 0
                    ret.forEach((it) => {
                        var item = it.car_category_name + it.car_code
                        if (carTmp.indexOf(item) == -1) {
                            carTmp.push(item)
                            that.cars.push({ id: idx, name: item })
                            idx = idx + 1
                        }
                    });
                    carTmp.forEach((it) => {
                        var tmp = ret.filter((itm) => itm.car_category_name + itm.car_code == it)
                        that.data.push(tmp)
                    })
                    console.log(that.cars)
                    if (carTmp.length>0) {
                        that.curCar = carTmp[0]
                        that.curData = that.data[0]
                    }
                    console.log(that.data)
               } else {
                   toErrorPage(that,'错误',ret.info,null)
               }

            })
        },
        clickback() {
            try {
                this.$router.go(-1)
            } catch {
                this.$router.push(`/nt/user/membercentre`)
            }
        },
        chgCar(itm) {
            this.showCar = false
            this.curData = this.data[itm.id]
            this.curCar = itm.name
        }
    }
}
</script>

<style lang="less" scoped>
#repairremind {
    .div_class {
        margin-left:5%;
    }
}
</style>